import { createGlobalState, useStorage } from '@vueuse/core';
import { computed } from 'vue';

const STORAGE_KEY = 'voxie-notification-sounds-muted';
const LEGACY_STORAGE_KEY = 'audio-muted';

export const useNotificationSounds = createGlobalState(() => {
    // One-time migration from the legacy un-namespaced key that
    // NewMessageNotification.vue wrote before this composable existed.
    // The old code only ever set the key to 'true' or removed it.
    if (window.localStorage.getItem(LEGACY_STORAGE_KEY) === 'true') {
        window.localStorage.setItem(STORAGE_KEY, 'true');
        window.localStorage.removeItem(LEGACY_STORAGE_KEY);
    }

    const muted = useStorage(STORAGE_KEY, false);

    const soundsEnabled = computed({
        get: () => !muted.value,
        set: (value: boolean) => {
            muted.value = !value;
        },
    });

    const toggleMute = (): void => {
        muted.value = !muted.value;
    };

    return { muted, soundsEnabled, toggleMute };
});
